import { useEffect, useState } from "react";
import UploadCoursePageContainer from "../../components/courses/upload";
import { VideoData } from "../../types/Tables";
import { getAllVideos } from "../../services/api";


const UploadCourses = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [videoList, setVideoList] = useState<VideoData[]>([]);
  useEffect(() => {
    const videoData = async () => {
      setIsLoading(true);
      const result = await getAllVideos();
      setVideoList(result)
      setIsLoading(false);
    };
    videoData();
  }, []);
  return <UploadCoursePageContainer videoList={videoList} isLoading={isLoading} />;
};
export default UploadCourses;
